import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import GridControl from "../../../Controls/GridControl"
import ShowOwnerResidentialInfo from "../../../Controls/ShowOwnerResidentialInfo"

import { 
	GetLocal,
	FetchService
} from "../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../Base/BasePageEmployee';

export default function Index(props) {
	
	const [getServiceResult, setServiceResult] = useState(false);

    useEffect(() => {

    }, []);

	const ShowLastCertificate =()=>{
        var inputValue = {
            session: GetLocal('EmployeeSession'),
			fileNumber: GetLocal('FileNumber'),
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Request/ShowLastCertificate", inputValue, ShowLastCertificateSuccess);		
	}

	const ShowLastCertificateSuccess =(ServiceResult)=>{
		setServiceResult(ServiceResult);
	}		
	
	const onClicks =()=>{
		ShowLastCertificate();
	}	

    return (
        <div class="text-center">	
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			
			{getServiceResult == false && 
				<ButtonControl 
					variant="btn btn-primary w-25"
					title="چاپ گواهی"
					icon="fa fa-file-pdf-o"
					onClick={onClicks}
				/>
			}
			
			{getServiceResult != false && <iframe src={"data:application/pdf;base64,"+getServiceResult} width="100%" height="600"></iframe> }
        </div>
    );
}
